import React, {useState,useEffect}  from "react";
import {useDispatch, useSelector} from 'react-redux'
import Logo from "../../../assets/images/logo.svg";
import MainHeader from "../../layout/MainHeader";
import TextField from "../../common/form/TextField";
import PasswordField from "../../common/form/PasswordField";
import GrowingLoader from "../../common/loaders/GrowingLoader";
import { useFormik } from "formik";
import * as Yup from "yup";
import loginUser from "../../../ajax/actions/Oauth/login/login_post";
import useAppState from "../../../hooks/useAppState";

const Login = () =>
{
  const [ submitted, setSubmitted ] = useState( false )

  const userDetails = useAppState( s => s.userDetails );
  const userLogin = useAppState( s => s.userLogin );

  const dispatch = useDispatch();
  useEffect(() => {
    // document.body.classList.add('login-pages')
    return () => {
      document.body.classList.remove('login-pages');
    }
  },[]);

  const { handleChange, handleSubmit, errors, touched, values, handleBlur } = useFormik(
      {
        initialValues: { username: ``, password: ``, device_type:'web' },
        enableReinitialize: true,

        validationSchema: Yup.object().shape({
          username: Yup.string().required('is required').email(` must be a valid email address.`),
          password: Yup.string().required('is required'),
        }),

        onSubmit: values => dispatch( loginUser( values ))
      })

  const { username, password } = values;

  const onSubmit = e =>
  {
    setSubmitted( true )
    handleSubmit( e )
  }

  useEffect( () => {
    let { success,  } = userDetails;
    if( success ) {
      window.location.href = '/';
    }
  }, [userDetails.success])

  return (
    <>
      <MainHeader/>
      <section className="dashboard-login">
        {/*<LoginWorker/>*/}
        <div className="form-block">
          <div className="logo-block">
            <img src={Logo} alt=""/>
          </div>
          <form onSubmit={onSubmit}>
            <TextField
                name="username"
                label="Email Address"
                placeholder="Your email"
                onChange={handleChange}
                value={username}
                error = {errors && errors.username}
                touched={ touched.username }
            />

            <PasswordField value={password}
                           name="password"
                           placeholder="Enter your password"
                           onChange={handleChange}
                           touched={ touched.password }
                           onBlur={handleBlur}
                            error = {errors && errors.password} />

            <div className="button-wrapper text-center mt-40">
              <button className="btn-theme btn-blue w-100" type="submit" >
                { userLogin && userLogin.processing ? <GrowingLoader /> : `Login`}
              </button>
              {/*<a className="btn-theme btn-blue w-100" type="submit" onClick={onSubmit}>
                { userLogin && userLogin.processing ? <GrowingLoader /> : `Login`}
              </a>*/}
            </div>
          </form>
        </div>
      </section>
    </>
  )
};

export default Login;